const components = {
  // SDoc
  rmDocTip: "Bạn có muốn xóa tập tin này không? Nó không thể được phục hồi sau khi xóa.",
  searchPlaceholder: 'Tìm kiếm tệp hoặc thư mục',
  upload: 'Tải lên',
  newFolder: 'Thư mục mới',
  folderNamePlaceholder: 'Vui lòng nhập tên thư mục',
  cannotMoveToChild: 'Không thể di chuyển vào thư mục con',
  moveSuccess: 'Di chuyển thành công',
  moveFail: 'Di chuyển thất bại',
  moveToParent: 'Di chuyển lên thư mục cha',
  move: 'Di chuyển',
  moveTitle: 'Di chuyển',
  moving: 'Đang di chuyển: {{name}}',
  currentLocation: 'Vị trí hiện tại',
  rootDirectory: 'Gốc',
  noFolders: 'Không có thư mục',
  moveToHere: 'Di chuyển đến đây',
  cancel: 'Hủy',

  // Dict
  plDictName: "Vui lòng nhập tên",
  plDictDesc: "Vui lòng nhập mô tả",
  dictName: 'Tên',
  dictDesc: 'Mô tả',

  // Selector
  plCountry: "Vui lòng chọn quốc gia/khu vực",
  plCreditLevel: "Vui lòng chọn mức tín dụng",
  plCurrency: "Vui lòng chọn loại tiền tệ",
  plProduct: "Vui lòng chọn sản phẩm",

  // 详情弹窗
  plContent: 'Vui lòng nhập nội dung',
  send: 'Gửi đi',
  reply: 'Trả lời',
  replyTo: 'Trả lời {{name}}',
  cancelReply: 'Hủy trả lời',
  replyCount: '{{name}} phản hồi',
  collapseReplies: 'Ẩn phản hồi',
  cameraUpload: "Chụp ảnh & tải lên",
  takePhoto: "Chụp ảnh",
  switchCamera: "Chuyển camera",
};

export default components;
